import { useTranslation } from "react-i18next";
import Container from "../element/container";
import Icon from "../element/icon";
import SubmittedMedia from "./submitted.media";

export default function DocumentUpload({ name, label, optional, note, file, readOnly, document, error, onChange }) {
  const { t } = useTranslation();
  const selectFile = (files) => {
    if (files?.[0]) onChange(files[0]);
  };

  return (
    <label className="purchase-upload">
      <span>
        {label}{optional && <> <small className="field-readonly-note">({t("Optional")})</small></>}
      </span>
      {readOnly ? <SubmittedMedia document={document} /> : <>
        <span
          className="purchase-upload-box"
          onDragOver={(event) => event.preventDefault()}
          onDrop={(event) => {
            event.preventDefault();
            event.stopPropagation();
            selectFile(event.dataTransfer.files);
          }}
        >
          <Icon icon="material-symbols:upload-rounded" />
          <span className="purchase-upload-copy">
            <span className="_label purchase-upload-name">{file?.name || t("Upload File")}</span>
            {!file?.name && <small className="accept-file-label">{t("JPG, PNG or PDF")}</small>}
          </span>
        </span>
        <input
          className="purchase-upload-input"
          type="file"
          name={name}
          accept=".jpg,.jpeg,.png,.pdf"
          onChange={(event) => selectFile(event.currentTarget.files)}
        />
      </>}
      {note && <small className="field-readonly-note">{note}</small>}
      {error && <Container tag="div" className="element _errors">{error}</Container>}
    </label>
  );
}
